module.exports = __webpack_public_path__ + "static/media/icon-trash-white.c0e64f38.svg";